import * as _ from "lodash";
import { Record } from "immutable";
import { createRecord } from "records/item";
import type { IItemRecord, IProduct } from "records/item/item";
import type { IScope } from "reducers/scope";
import { getStore } from "store";
import me from "models/me";

import { isProductCustomizationEnabled } from "components/customization-modal/helpers";

export const createProductRecord = (product: IProduct): IItemRecord => {
    if (product instanceof Record) {
        return product as IItemRecord;
    }

    const { entities } = getStore().getState();
    const productSchema = _.find(_.get(entities, "schemas"), { type: "product" });

    if (productSchema) {
        return new (createRecord(productSchema))(product);
    }

    return null;
};

export const calculatePrices = (
    productRecord: IItemRecord,
    scope: IScope,
): { msrp: string; wholesale: string } | null => {
    if (!productRecord) {
        return null;
    }

    const currencyCode = !me.isGuestBuyer()
        ? scope.currencyCode || me._activeCurrency
        : _.get(scope.brand, "settings.default_currency");
    return {
        wholesale: productRecord.formatPriceRange(currencyCode, scope),
        msrp: productRecord.formattedMSRPRange(currencyCode, scope),
    };
};

export const isProductCustomizable = (product?: IItemRecord, scope?: IScope) => {
    const allowCustomizations = !!isProductCustomizationEnabled(scope?.brand, scope?.company);
    return allowCustomizations && !!product?.__product_customizations_template_id;
};

export const imageFallback = "//cdn1.nuorder.com/brands/1womenswholesale_missing.jpg";
